<template>
  <div
    class="flex flex-row gap-8 items-center mb-8 md:mb-12"
    aria-hidden="true"
  >
    <div
      v-for="color in colors.slice(0, 5)"
      :key="productId + 'colorList' + color.ColorName"
      :style="{ backgroundColor: color.Color }"
      class="w-16 h-16 border-solid border-1 border-border-tertiary rounded-full"
    />
    <div v-if="Number(colors.length) - 5 > 0" class="body-bold-sm">
      +{{ Number(colors.length) - 5 }}
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { ColorDto } from '~/models/ListingProduct.api.model';

interface Props {
  colors?: ColorDto[];
  productId?: number;
}

withDefaults(defineProps<Props>(), {
  colors: () => [],
  productId: undefined,
});
</script>

<style lang="scss" scoped></style>
